import { useMemo } from "react";

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalPath?: string;
  ogType?: string;
  jsonLd?: Record<string, unknown>;
  children?: React.ReactNode;
}

const SITE_URL = (typeof import.meta !== "undefined" && import.meta.env?.VITE_SITE_URL) || "https://chronosspace.com";
const BRAND = "速築美宅家 Chronos Space";

function buildCanonical(path?: string): string {
  const base = SITE_URL.replace(/\/+$/, "");
  const clean = (path || "/").replace(/\/+$/, "") || "/";
  return `${base}${clean}`;
}

export default function SEOMeta({
  title,
  description,
  keywords,
  canonicalPath,
  ogType = "website",
  jsonLd,
}: SEOProps) {
  const fullTitle = useMemo(
    () => (title.includes(BRAND) ? title : `${title}｜${BRAND}`),
    [title],
  );
  const canonical = useMemo(() => buildCanonical(canonicalPath), [canonicalPath]);
  const jsonLdStr = useMemo(() => (jsonLd ? JSON.stringify(jsonLd) : null), [jsonLd]);

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content={BRAND} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {jsonLdStr ? (
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: jsonLdStr }} />
      ) : null}
    </>
  );
}